/* EOG scroll-reveal + sticky-header shadow. Loaded once from layout/theme.liquid (deferred).
   Elements start hidden via CSS ([data-eog-anim*]); this reveals them as they enter the viewport.
   Reduced-motion and no-JS visitors are handled in eog-v2.css and a <noscript> rule in the layout. */
(function () {
  if (window.__eogRevealInit) return;
  window.__eogRevealInit = true;

  var SELECTOR = '[data-eog-anim],[data-eog-anim-scale],[data-eog-anim-left]';

  function show(el) {
    el.style.opacity = '1';
    if (el.hasAttribute('data-eog-anim')) el.style.transform = 'translateY(0)';
    else if (el.hasAttribute('data-eog-anim-scale')) el.style.transform = 'scale(1)';
    else if (el.hasAttribute('data-eog-anim-left')) el.style.transform = 'translateX(0)';
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' })
    : null;

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (observer) observer.observe(el); else show(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  /* Theme editor: reveal sections as they are added or re-rendered */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  window.addEventListener('scroll', function () {
    var nav = document.querySelector('header');
    if (nav) nav.style.boxShadow = window.scrollY > 8 ? '0 2px 28px rgba(45,58,31,0.09)' : '';
  }, { passive: true });
})();
